export default __webpack_public_path__ + "static/media/fblogo.99c57394.svg";